import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { PromotionCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { chain, GetPromotions } from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import { GetCartPromotionsApiParameter } from "@NA/Services/ADICartService";

type HandlerType = ApiHandler<GetCartPromotionsApiParameter, PromotionCollectionModel>;

export const GetPromotionsCustom: HandlerType = async props => {
    props.apiResult = {
        promotions: [],
        uri: "",
        properties: {},
    };
};

replaceInChain(chain, GetPromotions, GetPromotionsCustom);
